export default "__VITE_ASSET__DgPJuX9S__"